import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61871768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "textRef" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.type ? `is-${_ctx.type}` : '',
      _ctx.type && _ctx.justify ? `is-justify-${_ctx.justify}` : '',
      _ctx.type && _ctx.align ? `is-align-${_ctx.align}` : '',
    ])
  }, [
    _createElementVNode("span", _hoisted_1, [
      (_ctx.$slots?.default?.())
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.val), 1))
    ], 512),
    (_ctx.textComputedRef)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "icon",
          onClick: _ctx.handleCopy
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CopyDocument)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ], 2))
}